import * as PIXI from "pixi.js";


export default class ShinyBandShader extends PIXI.Filter
{
    private _uniforms: PIXI.utils.Dict<any> = null;

    private _previousBandPos: number = null;


    public get uniforms(): PIXI.utils.Dict<any> { return this._uniforms; }


    public constructor()
    {
        const kFragShader = `
            precision mediump float;

            varying vec2 vTextureCoord;
            uniform sampler2D uSampler;

            uniform float time;
            uniform float bandWidth;
            uniform float speed;

            void main() {
                vec4 color = texture2D(uSampler, vTextureCoord);

                if (color.a < 0.01) {
                    gl_FragColor = color;
                    return;
                }

                // Compute diagonal projection using normalized vector (1, 1) / sqrt(2)
                float proj = dot(vTextureCoord, normalize(vec2(1.0, 1.0)));

                // Band moves from 0 to sqrt(2)
                float bandPos = mod(time * speed, sqrt(2.0));

                float dist = abs(proj - bandPos);
                float band = smoothstep(bandWidth, 0.0, dist);

                vec3 finalColor = min(color.rgb + band, vec3(1.0));
                gl_FragColor = vec4(finalColor, color.a);
            }
        `;

        const kUniforms: PIXI.utils.Dict<any> = {
            time: 0,
            bandWidth: 0.05,  // Adjust for sharpness or softness of band
            speed: 3       // Adjust speed of shine
        };
        
        super( undefined, kFragShader, kUniforms );

        this.padding = 16;
        this.resolution = 2;

        this._uniforms = kUniforms;
    }

    public update( dt: number ): void
    {
        if ( this.enabled )
        {
            const kBandPos = ( this._uniforms.time * this._uniforms.speed) % Math.sqrt( 2 );
            if ( this._previousBandPos !== null && this._previousBandPos > 1.3 && kBandPos < 0.1 ) 
            {
                this.enabled = false;
            }
            else
            {
                this._previousBandPos = kBandPos;

                this._uniforms.time += dt;
            }
        }
    }

    public reset(): void
    {
        this.enabled = true;
        this._previousBandPos = null;
    }
}